export class Labor {
    labor_id: number;
    bezeichnung: string;
    strasse: string;
    plz: string;
    ort: string;
}
